import TripsByDirection from '@/components/manage/tickets/TripsByDirection';
import Divider from '@/components/primitives/Divider';
import { manageFlowBookingSelector } from '@/features/manage/manageSelectors';
import { useBookingTrips } from '@/hooks/useBookingTrips';
import { useSelector } from '@/store/utils';
import type { CheckoutOrBookingPassengerMap } from '@/types/passenger';
import type { FC } from 'react';

interface BookedTripsDetailsProps {
  passengersMap: CheckoutOrBookingPassengerMap;
}

const Tickets: FC<BookedTripsDetailsProps> = ({ passengersMap }) => {
  const booking = useSelector(manageFlowBookingSelector);
  const { outboundTrips, inboundTrips } = useBookingTrips(booking);

  return (
    <div className="flex flex-1 flex-col">
      <TripsByDirection
        trips={outboundTrips}
        passengersMap={passengersMap}
        header="outboundTrips"
      />
      {!!inboundTrips.length && (
        <>
          <Divider className="my-4" grow={false} />
          <TripsByDirection
            trips={inboundTrips}
            passengersMap={passengersMap}
            header="returnTrip"
          />
        </>
      )}
    </div>
  );
};

export default Tickets;
